import {
  emailNotificationBlackListPaginated,
  emailNotificationBlacklistContent
} from 'types/EmailNotificationBlackListTypes';
import useHttp from '../helpers/HttpMethods';

class EmailNotificationBlackListService {
  /**
   * Busca a blacklist de notificações por e-mail (solicitante).
   * @param {string} filter - Query string (page, size).
   * @returns {Promise<emailNotificationBlackListPaginated>}
   */
  static async list(filter: string): Promise<emailNotificationBlackListPaginated> {
    return await useHttp().get(`/email-notifications/blacklist?${filter}`);
  }

  /**
   * Adiciona e-mail(s) à blacklist de notificações (solicitante).
   * @param {{ sender: string[] }} body - Array de e-mails.
   * @returns {Promise<emailNotificationBlacklistContent[]>}
   */
  static async add(body: { sender: string[] }): Promise<emailNotificationBlacklistContent[]> {
    return await useHttp().post(body, `/email-notifications/blacklist`);
  }

  /**
   * Remove um e-mail da blacklist de notificações.
   * @param {number} id - ID do item na blacklist.
   * @returns {Promise<Response>}
   */
  static async delete(id: number): Promise<Response> {
    return await useHttp().del(`/email-notifications/blacklist/${id}`);
  }
}

export default EmailNotificationBlackListService;
